<template>
<div class="chapter">
<div class="inner_page">
<p class="txc" id="d12e105">This book is dedicated with love and gratitude <br/>to our Women of Faith intercessor, Lana Bateman. <br/>You have taught me so much about living a <br/>life of prayer, and I thank our Father for you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Wals_ISBN1418537640_epub_c3_r1.vue?c0b6bbfa